<!-- <div class="main-container">
    <div class="login-container">
        <div class="header-container">
        </div>
        <div class="content">
            <p class="login-text">Sign in with your Deloitte ID</p>
            <div class="custom-button">
                <button label="Login" styleClass="button-width" (click)="login()"></button>
            </div>
        </div>
    </div>
</div> -->

<section class="text-center mx-0 md:mx-8 lg:mt-7 md:mt-3 sm:mt-1" >
    <div class="grid">
        <div class="lg:col-6 md:col-8 mx-auto">
            <h1 class="title">Deloitte Boardroom</h1>
            <p class="lead text-body-secondary lg:col-9 md:col-12 pt-4 mx-auto">
                Deloitte Boardroom translates and provides transcript for your audio files seamlessly. Upload your
                audio
                file and get them translated in minutes
            </p>
            <p class="pt-6">
                <a class="btn btn-primary my-2  started mx-auto" (click)="login()" >Login with SSO<i class="fa-sharp fa-solid fa-key"></i></a>
            </p>
        </div>

    </div>
</section>